query totalPublicacaoNumeroProcesso($where: PublicacaoNumeroProcessoModelFilterInput) {
    data: publicacoesNumeroProcessosOffsetPagination(
        where: $where) {
        totalCount
    }
}